import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { editConcept } from "../api/editConcept";
import type { ConceptData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useEditConcept = (): UseMutationResult<ApiResponse, ApiError, ConceptData> => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: editConcept,
        onSuccess: () => {
             queryClient.invalidateQueries({ queryKey: withPrefix(['concepts']) });
        }
    })
}
